import script from "./UploadProjectAttachmentsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadProjectAttachmentsModal.vue?vue&type=script&setup=true&lang=ts"

import "./UploadProjectAttachmentsModal.vue?vue&type=style&index=0&id=a87c5ca0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a87c5ca0"]])

export default __exports__